module.exports = __webpack_public_path__ + "static/media/logo.dbdf31ed.png";